import React from "react";
import { Link } from "react-router-dom";

const Dashboard = () => {
  return (
    <div>
      Dashboard
      <Link to="test1"> test1</Link>
    </div>
  );
};

export default Dashboard;
